<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CB2JZ7/tc-custom/9781611525830.jpg?1718106505635" alt="This image is the cover for the book You Again?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Again?
      </h1>
      <p class="bookDescription body article font2">
        <p>Henry Kavalauskas spends most of his time at YVR, Vancouver’s international airport. He works there, he hangs out there -- he knows the world is bigger than his fast-food job and his parents' living room, and he wishes he could find a guy to take him out into it. Someone to shepherd him through its teeming cities and sleep beside him in its fine hotels.<br/><br/>Someone like Zack Hoffman, to be quite specific, although Henry's first encounter with the short, sexy business traveler seems destined to be his last, seeing as how it takes place in an airport men's room.<br/><br/>But Zack's long-haul flight is canceled, and when their paths cross again quite by chance -- and Zack produces the key to a hotel room -- Henry seizes the moment. The room's gorgeous, Naked Zack is gorgeous, and being with him is a dream come true for Henry. Until reality barges in, chases Henry half-naked back into the airport, and raises some questions about Zack. Is he who he says he is? And, more importantly, will Henry ever see him again?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael P. Thomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c17372d